import { LINKS } from '@/Module/Core/Constant';
import type { IMenuItem } from '@/Module/DefaultLayout/Model';
import { DesktopSectionTypes } from '@/Module/DefaultLayout/Model';
import {
  IconLearningActive,
  IconLearningUsual,
  IconSearchActive,
  IconSearchUsual,
  IconSubscriptionActive,
  IconSubscriptionUsual,
  IconWorkspaceActive,
  IconWorkspaceDeActive,
} from '@/Module/Icon';

export const MenuItem: IMenuItem[] = [
  {
    key: DesktopSectionTypes.WORKSPACE,
    href: LINKS.WORKSPACE.MAIN,
    title: 'میزکار',
    iconActive: IconWorkspaceActive,
    iconUsual: IconWorkspaceDeActive,
  },
  {
    key: DesktopSectionTypes.LEARNING,
    href: LINKS.LEARNING,
    title: 'یادگیری',
    iconActive: IconLearningActive,
    iconUsual: IconLearningUsual,
  },
  {
    key: DesktopSectionTypes.SEARCH,
    href: LINKS.DISCOVER,
    title: 'جستجو',
    iconActive: IconSearchActive,
    iconUsual: IconSearchUsual,
  },
  {
    key: DesktopSectionTypes.SUBSCRIPTION,
    href: LINKS.SUBSCRIPTION.MAIN,
    title: 'اشتراک',
    iconActive: IconSubscriptionActive,
    iconUsual: IconSubscriptionUsual,
  },
];
